<div class="tools-container" [formGroup]="toolsFormGroup">
  <h4 class="tools-title">{{ 'PRESENTER.VIDEO_TOOLS.TITLE' | translate }}</h4>

  <mat-form-field>
    <mat-label>{{ 'PRESENTER.VIDEO_TOOLS.EMBED_URL' | translate }}</mat-label>
    <input matInput [formControl]="embedUrlControl" />
    <mat-hint>{{ 'PRESENTER.VIDEO_TOOLS.EMBED_URL_HINT' | translate }}</mat-hint>
  </mat-form-field>
</div>
